import React, { useState } from 'react';

const AddRetailItem = ({ addItem }) => {
  const [item, setItem] = useState({
    name: '',
    rate: 0,
    amount: 0,
    igst_percent: 0,
    cgst_percent: 0,
    sgst_percent: 0,
  });
const [errors, setErrors] = useState([]);

  function toFixedDigit(n, noOfDigits) {
    return n.toString().padStart(noOfDigits, '0');
}

function toFixedDigitFloat(n, noOfDigit, noOfDigitAfterDecimal) {
    let [intPart, decimalPart] = n.toFixed(noOfDigitAfterDecimal).split("."); // Ensures decimal part has fixed digits
    intPart = intPart.padStart(noOfDigit, "0"); // Zero-pad the integer part
    return `${intPart}.${decimalPart}`;
}

function numberToWords(num) {
  if (num === 0) return "Zero";

  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function helper(n) {
    let word = "";

    if (n < 10) word = units[n];
    else if (n < 20) word = teens[n - 10];
    else if (n < 100) word = tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "");

    return word;
  }

  let result = "";
  let afterHundred = false; // flag to track if 'and' is needed

  for (const scale of scales) {
    if (num >= scale.value) {
      const scaledNum = Math.floor(num / scale.value);
      result += helper(scaledNum) + " " + scale.name + " ";
      num = num % scale.value;
      if (scale.value === 100) afterHundred = true;
    }
  }

  if (num > 0) {
    if (afterHundred) {
      result += "and ";
    }
    result += helper(num);
  }

  return result.trim();
}

  const handleChange = (e) => {
    const { name, value } = e.target;
    let parsedValue =
    name === 'name'
      ? value
      : Math.max(parseFloat(value) || 0, 0);
    
    setItem((prev) => {
      const updated = {
        ...prev,
        [name]: parsedValue,
      };
  
      // Recalculate taxes and total if relevant fields change
      const amount = name === 'amount' ? parsedValue : updated.amount || 0;
      const igst = name === 'igst_percent' ? parsedValue : updated.igst_percent || 0;
      const cgst = name === 'cgst_percent' ? parsedValue : updated.cgst_percent || 0;
      const sgst = name === 'sgst_percent' ? parsedValue : updated.sgst_percent || 0;
  
      const igst_amount = (igst * amount) / 100;
      //const igst_amount = Number(((igst * amount) / 100).toFixed(2));
      const cgst_amount = (cgst * amount) / 100;
      const sgst_amount = (sgst * amount) / 100;
      const total_amount =Math.round(amount + igst_amount + cgst_amount + sgst_amount);
  
      return {
        ...updated,
        igst_amount,
        cgst_amount,
        sgst_amount,
        total_amount,
      };
    });
  };
  

  const handleAdd = () => {
    const errors = [];
  
    if (!item.name || item.name.trim() === '') {
      errors.push('Item name is required.');
    }
  
    if (!item.amount || item.amount <= 0) {
      errors.push('Item amount must be greater than 0.');
    }
  
    if (errors.length > 0) {
      setErrors(errors); // Assuming you have a state variable: const [errors, setErrors] = useState([]);
      return;
    }
  
    setErrors([]); // Clear previous errors
  
    const igst_amount = ((item.igst_percent * item.amount) / 100);
    const cgst_amount = ((item.cgst_percent * item.amount) / 100);
    const sgst_amount = ((item.sgst_percent * item.amount) / 100);
    const total_amount = Math.round(item.amount + igst_amount + cgst_amount + sgst_amount);
  
    const newItem = {
      ...item,
      igst_amount,
      cgst_amount,
      sgst_amount,
      total_amount,
    };
  
    addItem(newItem);
  
    // Reset form
    setItem({
      name: '',
      rate: 0,
      amount: 0,
      igst_percent: 0,
      cgst_percent: 0,
      sgst_percent: 0,
    });
  };
  
  return (
    <div className="p-1 bg-gray-100 rounded-md  space-y-2">
        <label>Description*:</label>
        <textarea
  name="name"
  value={item.name}
  onChange={handleChange}
  onInput={(e) => {
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  }}
  placeholder="Item Name"
  className="w-full p-2 border rounded resize-none overflow-hidden"
/>
<label>Rate:</label>
      <input
        type="number"
        name="rate"
        value={item.rate}
        onChange={handleChange}
        placeholder="Rate" onWheel={(e) => e.target.blur()}
        className="w-full p-2 border rounded"
      />
     
    
      <div className="flex gap-2w-full  grid grid-cols-[1fr_1fr_1fr_1fr] gap-1 p-1 text-sm">
      <div className='flex flex-col justify-center items-center'>
      <label>Amount*:</label>
      <input
        type="number"
        name="amount"
        value={item.amount}
        onChange={handleChange}
        placeholder="Amount" onWheel={(e) => e.target.blur()}
        className="w-full p-2 border rounded"
      />  <p className='text-transparent'>{item.amount||0}</p></div>

      <div className='flex flex-col justify-center items-center'><label>IGST%:</label>
        <input
          type="number"
          name="igst_percent"
          value={item.igst_percent}
          onChange={handleChange}
          placeholder="IGST %"
          className="w-full p-2 border rounded" onWheel={(e) => e.target.blur()}
        />
        <p>{item.igst_amount||0}</p>
        </div>
      <div className='flex flex-col justify-center items-center'> <label>SGST%:</label>
      <input
          type="number"
          name="sgst_percent"
          value={item.sgst_percent}
          onChange={handleChange}
          placeholder="SGST %"
          className="w-full p-2 border rounded"  onWheel={(e) => e.target.blur()}
        /><p>{item.sgst_amount||0}</p>
        </div>
      <div className='flex flex-col justify-center items-center'><label>CGST%:</label>
      <input
          type="number"
          name="cgst_percent"
          value={item.cgst_percent}
          onChange={handleChange}
          placeholder="CGST %"
          className="w-full p-2 border rounded" onWheel={(e) => e.target.blur()}
        /><p>{item.cgst_amount||0}</p>
       </div> 
      </div>

      
      <div className='flex flex-wrap'>
        <p className="text-center">
            Item Total Amount RT:       
        <span className="text-center px-4">
        {toFixedDigitFloat(item.total_amount||0,1,2)}
        </span>
        <span className="text-center px-4">
        ({numberToWords(item.total_amount||0)})
        </span></p>

      </div>
      <div className='w-full flex items-center justify-center'>
      <button
        onClick={handleAdd}
        className="p-2 bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
      >
        Add Item
      </button></div>
      {errors.length > 0 && (
  <div className="w-full flex flex-col items-center justify-center text-red-500 text-sm">
    {errors.map((err, idx) => (
      <p key={idx}>{err}</p>
    ))}
  </div>
)}
    </div>
  );
};

export default AddRetailItem;
